import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

import Connection from '../../Calls';
import Backend from '../../Backend';

import NoCommerce from '../../Images/noTransaction.svg'

class ModalEcom extends Component {
  constructor(props){
    super(props)
    this.state = {

    }
  }

  ecommLead(){
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var payload = response.payload
      Backend.ecomm_lead(payload.r01)
    })
    this.props.history.push('/ecommerce/create')
  }

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onHide} className='ecomm-modal-container'>
        <Modal.Body>
          <div className='ecomm-modal'>
            <img src={NoCommerce} style={{width:80, marginBottom:10}}/>
            <p className='blue-text bmargin0'>
              {this.props.traductions.ecomm.modal.title}<br/>
            </p>
            <p className='gray-text'>
              {this.props.traductions.ecomm.modal.text}
            </p>
            <Button className='ecommerce-button' onClick={()=>this.ecommLead()}>{this.props.traductions.ecomm.modal.button}</Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}export default ModalEcom
